import { useWPApi, wpApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { useEffect, useState } from 'react';

import he from 'he';
import getPreviewMode, { PreviewModeType } from '@gik/core/utils/PreviewMode';
const PATH = 'featured-inkind';

export interface PageCategory {
  name: string;
  slug?: string;
  id: number;
  acf: {
    preview_mode: boolean;
  };
}

interface PageCategoryOption {
  value: string;
  label: string;
}

export function usePageCategories(): [PageCategoryOption[], boolean] {
  const [pageCategories, setPageCategories] = useState<PageCategoryOption[]>();
  const { data: wpCategoriesResponse, isValidating } = useWPApi<PageCategory[]>(PATH);

  useEffect(() => {
    if (wpCategoriesResponse) {
      setPageCategories(
        wpCategoriesResponse
          ?.filter(category => !category.acf.preview_mode || getPreviewMode(PreviewModeType.HomePage))
          ?.map(category => {
            return {
              label: he.decode(category.name),
              value: category.id.toString(),
            };
          })
      );
    }
  }, [wpCategoriesResponse]);

  return [pageCategories, isValidating];
}

export async function getPageCategories(): Promise<PageCategory[]> {
  const apiResponse: ResponsePromise = wpApi.get(PATH);
  return await apiResponse.json<PageCategory[]>();
}
